/**
 * PL-17 (docs/integration-portal-link-proposal.md §11 in the SVN repo): signing out of the app ends
 * every portal session of that person, on every device and in every workspace.
 *
 * Fire and forget. The call goes out with the token that is still valid at that moment, on plain
 * axios rather than the shared client: the shared client answers a 401 by refreshing and, failing
 * that, by signing out again, and a sign-out must never loop or wait on this. Its answer, or its
 * failure, is never looked at.
 */
import axios from "axios";

/**
 * @param {string} token      the access token, read before it is cleared
 * @param {string} baseURL    the API base (webAppConfig.baseURL)
 * @param {Function} [post]   axios.post, replaceable in tests
 * @returns {boolean} whether a request was sent
 */
export function endPortalSessionsOnSignOut(token, baseURL, post) {
  if (!token || token === "undefined" || token === "null") return false;
  const send = post || axios.post;
  try {
    const request = send("/api/portal/sessions/end", {}, {
      baseURL,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
    });
    if (request && typeof request.catch === "function") request.catch(() => {});
    return true;
  } catch (err) {
    return false;
  }
}

export default { endPortalSessionsOnSignOut };
